/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextBulletGroupIcon16Light } from './TextBulletGroupIcon16Light';
import { TextBulletGroupIcon16Regular } from './TextBulletGroupIcon16Regular';
import { TextBulletGroupIcon16Solid } from './TextBulletGroupIcon16Solid';
import { TextBulletGroupIcon20Light } from './TextBulletGroupIcon20Light';
import { TextBulletGroupIcon20Regular } from './TextBulletGroupIcon20Regular';
import { TextBulletGroupIcon20Solid } from './TextBulletGroupIcon20Solid';
import { TextBulletGroupIcon24Regular } from './TextBulletGroupIcon24Regular';
import { TextBulletGroupIcon24Solid } from './TextBulletGroupIcon24Solid';
import { TextBulletGroupIcon32Regular } from './TextBulletGroupIcon32Regular';
import { TextBulletGroupIcon64Regular } from './TextBulletGroupIcon64Regular';
var sizes = {
    16: {
        light: TextBulletGroupIcon16Light,
        regular: TextBulletGroupIcon16Regular,
        solid: TextBulletGroupIcon16Solid,
    },
    20: {
        light: TextBulletGroupIcon20Light,
        regular: TextBulletGroupIcon20Regular,
        solid: TextBulletGroupIcon20Solid,
    },
    24: {
        regular: TextBulletGroupIcon24Regular,
        solid: TextBulletGroupIcon24Solid,
    },
    32: {
        regular: TextBulletGroupIcon32Regular,
    },
    64: {
        regular: TextBulletGroupIcon64Regular,
    },
};
export var TextBulletGroupIcon = forwardRef('TextBulletGroupIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
